<template>
  <div ref="pieChart" style="height: 100%;width: 100%"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'pieChart',
  props: {
    // title: {
    //   type: String,
    //   default: ''
    // },
    // chartId: {
    //   type: String,
    //   default: ''
    // },
    dataList: {
      type: Array,
      default: () => []
    },
    // loading: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data () {
    return {
      list: []
    }
  },
  watch: {
    dataList: {
      // immediate: true,
      handler (newVal) {
        this.list = newVal
        this.initEcharts()
      }
    }
  },
  mounted () {
    this.list = [...this.dataList]
    this.initEcharts()
  },
  methods: {
    initEcharts () {
      // 基本柱状图
      const option = {
        legend: {
          show: false
        },
        tooltip: {},
        dataset: {
          source: [
            ['product', '2015', '2016'],
            ['Matcha Latte', 43.3, 85.8],
            ['Milk Tea', 83.1, 73.4],
            ['Cheese Cocoa', 86.4, 65.2],
            ['Walnut Brownie', 72.4, 53.9]
          ]
        },
        series: [{ type: 'pie' }]
      }
      let myChart = echarts.getInstanceByDom(this.$refs.pieChart)
      if (myChart == null) {
        myChart = echarts.init(this.$refs.pieChart)
      }
      // myChart.showLoading({
      //   text: 'loading',
      //   color: '#c23531',
      //   textColor: '#000',
      //   maskColor: 'rgba(255, 255, 255, 0.8)',
      //   zlevel: 0
      // })
      myChart.setOption(option, true)
      // myChart.hideLoading()
      // 随着屏幕大小调节图表
      window.addEventListener('resize', () => {
        myChart.resize()
      })
    }
  }
}
</script>

<style scoped>

</style>
